import { render, staticRenderFns } from "./OrticTextPreview.vue?vue&type=template&id=35cc27ca&scoped=true&"
import script from "./OrticTextPreview.vue?vue&type=script&lang=js&"
export * from "./OrticTextPreview.vue?vue&type=script&lang=js&"
import style0 from "./OrticTextPreview.vue?vue&type=style&index=0&id=35cc27ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cc27ca",
  null
  
)

export default component.exports